import React, { useEffect, useState } from "react";
import { Button, Tab, Tabs, Form, Modal, ModalBody, InputGroup } from "react-bootstrap";
import WithdrawSearchbar from "../searchbar/withdrawSearchbar";
import WithdrawDropdown from "../searchbar/withdrawDropdown";
import { HiClipboardDocumentList } from "react-icons/hi2";
import { HiOutlineDocumentSearch } from 'react-icons/hi'
import { AiFillPlusCircle } from 'react-icons/ai'
import { updateAddress } from "../../../store/withdraw";
import { useDispatch } from "react-redux";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import { api_key,AXIOS } from "../../../config";
import ListGroup from 'react-bootstrap/ListGroup';
export default function WithdrawTabs({ walletInfo }) {
  let userid = sessionStorage.getItem('userid')

  const dispatch = useDispatch();
  const navigate = useNavigate()
  const [address, setAddress] = useState("");
  const [addressBookAddress, setAddressBookAddress] = useState({
    label:''
  });

  const [isModalOpen, setModalOpen] = useState(false);
  const [addressBook,setAddressBook] = useState(Array(10).fill('0xd0eE3f4c497805231A4BFfC57C734239583952A5'))
  const [selectedOption, setSelectedOption] = useState(null);

  const [error, setError] = useState("");
  const handleAddress = async (e: any) => {
    setAddress(e.target.value);
    dispatch(updateAddress(e.target.value));
    if (e.target.value.trim() === "") {
      setError("Required field");
    } else {
      setError("");
    }
  };

  function openModal() {
    setModalOpen(true);
  }
  function closeModal() {
    setModalOpen(false);
  }
const getAdressBook= async()=>{
  try {   
    const response = await AXIOS.post('', {
      api_key: api_key,    
      user_id: userid,
    });
  

    console.log('withdraw response', response)
  }
  catch (error: any) {
    console.log('error while withdraw', error.message)
  }
}
  useEffect(()=>{
    // getAdressBook()
  })

  return (
    <>
      <Tabs
        defaultActiveKey="home"
        transition={false}
        id="noanim-tab-example"
        className="mb-3 text-dark"
        style={{ color: "var(--text-clr)" }}
        onSelect={()=>{setAddress('');setAddressBookAddress({label:''})}}
      >
        {/* Address Tab */}
        <Tab eventKey="home" title="Use New Address">
          {/* Network Dropdown */}
          <WithdrawDropdown walletInfo={walletInfo} />
          {/* Address Input */}
          <div className="wd_add_srch mt-3">
            <div className="mb-2 ms-1">
              <span className="">Withdrawl Address</span>
            </div>
            <div className="input-wrapper">
              <input
                className="search_input"
                type="text"
                placeholder="Enter Withdrawl Address"
                value={address}
                onChange={(e) => handleAddress(e)}
              />
              <HiClipboardDocumentList id="clip-icon" />
            </div>
            <div className="text-danger">{error}</div>
          </div>
        </Tab>
        {/* Address Book Tab */}
        <Tab eventKey="profile" title="Address Book">
          <div className="bnc_usr_inp mt-2">
            <label htmlFor="" className="mb-2">
              Address Book
            </label>
            <Select
              onMenuOpen={openModal}
              isSearchable={false}
              value={addressBookAddress}
              
              placeholder="Select from address book"
              // onChange={setSelectedOption}

            />
          </div>
          <Modal show={isModalOpen} onHide={closeModal} centered backdrop={false}>
            <Modal.Header closeButton>
              <Modal.Title>Select from address book</Modal.Title>
            </Modal.Header>
            <ModalBody>
              {
                addressBook.length<1?<>
                 <div
                className="d-flex flex-column align-items-center justify-content-center"
                style={{ color: "var(--text-clr)" }}
              >


                <i className="display-6">
                  <HiOutlineDocumentSearch />
                </i>
                <span>Address not found</span>
              </div>
                </>:<>
                <ListGroup as="ol" numbered className="">
                {
                  addressBook.map((address,index)=>{
                    return(
                      <>
                       <ListGroup.Item style={{ cursor: "pointer" }} key={index} onClick={()=>{setAddressBookAddress({label:address});setAddress(address);closeModal()}}>{address} </ListGroup.Item>
                     
                      </>
                    )
                  })
                }
                </ListGroup>
               
              
                </>
              }
             
              <div className="d-flex justify-content-center align-items-center" style={{ marginTop: "2rem" }}>
                <Button className='bg-white border-0 text-warning' style={{ fontSize: "1.5rem" }} onClick={() => navigate('/withdraw/address')}> <AiFillPlusCircle />  Add</Button>

              </div>

            </ModalBody>
          </Modal>
        </Tab>
      </Tabs>
    </>
  );
}
